export default __webpack_public_path__ + "static/media/icon.2c9553eb.svg";